import React, { useState, useContext, useEffect, useRef } from 'react'
import { Search, List, TableProperties } from 'lucide-react';
import { CantiqueContextAPI } from '../Context/CantiqueContext';

const SidebardSearch = () => {
    const { searchTerm, setSearchTerm, viewMode, setViewMode } = useContext(CantiqueContextAPI);
    const [isSearchOpen, setIsSearchOpen] = useState(() => Boolean(searchTerm));
    const inputRef = useRef(null);

    useEffect(() => {
        if (searchTerm) setIsSearchOpen(true);
    }, [searchTerm]);

    const toggleSearch = () => {
        const next = !isSearchOpen;
        setIsSearchOpen(next);
        if (next) setTimeout(() => inputRef.current?.focus(), 50);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearchClear = () => {
        setSearchTerm('');
    };

    return (
        <div className="sidebardSearch">
            <div className="sidebardSearch__container">
                <div className="sidebardSearch__top">
                    <div className="sidebardSearch__top__left">
                        <h3 className="sidebardSearch__top__title">
                            Recherche
                        </h3>
                        <div className="sidebardSearch__top__icon__search">
                            <span
                                className={`${isSearchOpen ? 'is-open' : ''}`}
                                onClick={toggleSearch}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSearch(); } }}
                                role="button"
                                tabIndex={0}
                                aria-label="Afficher la recherche"
                                aria-expanded={isSearchOpen}
                            >
                                <Search size={14} className='sidebardSearch__icon' />
                            </span>
                        </div>
                    </div>
                    {/* Du coté Right */}
                    <div className="sidebardSearch__top__right">
                        <ul className="sidebardSearch__top__right__list">
                            {/* Par default la liste s'affiche en liste */}
                            <li
                            className={`sidebardSearch__top__right__item ${viewMode === 'list' ? 'active' : ''}`}
                            onClick={() => setViewMode('list')}
                            role="button"
                            tabIndex={0}
                        >
                             <List size={14} className='sidebardSearch__top__right__item__icon' />
                        </li>
                        {/* Bouton de switching version affichage par numerotation du cantique */}
                        <li
                            className={`sidebardSearch__top__right__item ${viewMode === 'number' ? 'active' : ''}`}
                            onClick={() => setViewMode('number')}
                            role="button"
                            tabIndex={0}
                        >
                            <TableProperties size={14} className='sidebardSearch__top__right__item__icon' />
                        </li>
                        </ul>
                    </div>
                </div>
                {/*  Input Search  */}
                <div className={`sidebardSearch__inputs ${isSearchOpen ? 'is-open' : ''}`}>
                    <input 
                        ref={inputRef}
                        type="search" 
                        className="sidebardSearch__inputs__search"
                        placeholder='Numéro, titre ou paroles…'
                        aria-label="Rechercher un cantique par numéro, titre ou paroles"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        onKeyDown={(e) => { if (e.key === 'Escape') handleSearchClear(); }}
                    />
                    {searchTerm && (
                        <button 
                            type="button"
                            aria-label="Effacer la recherche"
                            onClick={handleSearchClear}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#999'
                            }}
                        >
                            ✕
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default SidebardSearch